import { useFeatureFlagValue } from '@/hooks/useFeatureFlag';
import { validatePositiveNumber } from '@/utils/numberValidation';

export const useGetCashbackPercentageValue = (): number => {
  const value = useFeatureFlagValue('cashback-percentage-value');
  return validatePositiveNumber(value);
};
